module.exports = __webpack_public_path__ + "static/media/item_5_31_comp.72b99407.png";